export default __webpack_public_path__ + "static/media/rmnt1.fc434713.jpg";